import { z } from 'zod';

/**
 * The bands of a character's standing with a power (CHAR-REPUTATION), from the worst: what players
 * read over a hidden number. Ids are a public contract (wire, i18n `reputation.bands.<band>`):
 * never rename.
 */
export const REPUTATION_BANDS = [
  'sworn',
  'hostile',
  'wary',
  'neutral',
  'friendly',
  'honored',
  'exalted',
] as const;
export const ReputationBandSchema = z.enum(REPUTATION_BANDS);
export type ReputationBand = z.infer<typeof ReputationBandSchema>;

/** A power's id (CHAR-REPUTATION, RP-1): a settlement, a people, a guild (format only). */
export const PowerIdSchema = z.string().regex(/^[a-z][a-z0-9_]{0,39}$/);

/** A character's standing with each power that knows of it. */
export const ReputationSchema = z.object({
  powers: z.array(z.object({ id: PowerIdSchema, band: ReputationBandSchema })),
});
export type Reputation = z.infer<typeof ReputationSchema>;
